module.exports = __webpack_public_path__ + "static/results1.jpg";